<template>
  <div
    class="font-sans-semi-bold inline-flex aspect-square size-full items-center justify-center rounded-full border-2 border-white text-base !leading-normal text-white"
  >
    <slot />
  </div>
</template>
